import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Draggable from '@components/Draggable';
import Row from '@components/Row';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import InfoIcon from '@icons/InfoIcon';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import MyMenuFooter from './components/MyMenuFooter';
import MyMenuHeader from './components/MyMenuHeader';
import MyMenuItem from './components/MyMenuItem';
import styles from './styles.module.scss';

const MyMenuActivity: ActivityComponentType = () => (
        <AppScreen>
            <CtaLayout header={<MyMenuHeader/>}
                       footer={<MyMenuFooter />} >
                <Column className={styles.container}
                        fullWidth >
                    <Tooltip top={18} right={16}
                             backgroundColor={colors.gray6}
                             align='right'
                             visibleKey='myMenuSort' >
                        아이콘을 손으로 두번 터치하면<br/>
                        카드 순서를 변경할 수 있어요.
                    </Tooltip>
                    <Row className={styles.comment}>
                        <InfoIcon/>
                        <Text color={colors.gray9}
                              size='s' >
                            상단부터 순서대로 5개의 MY메뉴가 메인페이지에 노출됩니다.
                        </Text>
                    </Row>
                    <Draggable className={styles.contents} spacing={18}>
                        {Array.from({ length: 10 }).map((_, i) => (
                            <MyMenuItem key={`myMenu ${i}`}
                                        id={i.toString()} />
                        ))}
                    </Draggable>
                </Column>
            </CtaLayout>
        </AppScreen>
);

export default MyMenuActivity;
